import { defineGameCard } from '../authoring/index.js';
import { isSlimeDefinitionId, SLIME_RESIDUE_STACKS_KEY, slimeSetDependencies, } from './slime-helpers.js';
export const SlimeResidueCard = defineGameCard({
    id: 'slime_residue',
    gameplay: { type: 'EFFECT', cost: 0 },
    presentation: {
        name: 'Склизь',
        description: 'Постоянный эффект ячейки. Слизень в этой ячейке наносит на N больше исходящего урона.',
        glyph: {
            colors: ['#2E7D4A', '#5ECF6B', '#A8F0B0'],
            rows: [
                '.........',
                '.........',
                '.........',
                '.........',
                '..2..2...',
                '.222222..',
                '223222222',
                '222222322',
                '.1111111.',
            ],
        },
    },
    role: 'auxiliary',
    dependencies: slimeSetDependencies(),
    hooks: {
        modifyOutgoingDamage(ctx, planned) {
            const source = planned.sourceId === undefined ? null : ctx.q.instance(planned.sourceId);
            const value = ctx.effect?.vars[SLIME_RESIDUE_STACKS_KEY];
            const stacks = typeof value === 'number' && Number.isSafeInteger(value) && value >= 0 ? value : 0;
            return source !== null && isSlimeDefinitionId(source.defId)
                ? planned.amount + stacks
                : planned.amount;
        },
    },
    ui: {
        mechanics: ['slime_residue'],
        publicVars: { stacks: { key: SLIME_RESIDUE_STACKS_KEY, kind: 'number' } },
        locationEffect: {
            symbol: '💧',
            label: 'Склизь',
            description: 'Слизень в этой ячейке наносит на {value} больше исходящего урона.',
            counterFact: 'stacks',
            showCellBadge: true,
        },
        effectStatusProviders: [(_context, effects) => {
                const stacks = effects.reduce((total, effect) => {
                    const current = effect.facts.stacks;
                    return total + (typeof current === 'number' ? current : 0);
                }, 0);
                return stacks > 0
                    ? [{
                            id: 'slime-residue',
                            symbol: '💧',
                            label: `Склизь ${stacks}`,
                            description: `Слизень в этой ячейке наносит на ${stacks} больше исходящего урона.`,
                            tone: 'positive',
                            compact: true,
                        }]
                    : [];
            }],
    },
});
//# sourceMappingURL=slime_residue.js.map